import { createSlice } from "@reduxjs/toolkit";

const initialAttendanceState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  today: "",
  studentAttendances: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const teacherAttendanceSlice = createSlice({
  name: "teacherAttendance",
  initialState: initialAttendanceState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getSectionsAndCourseHours
    sectionsAndCourseHoursFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.today = entity && entity.date;
      state.sections = entity && entity.sections;
      state.courseHours = entity && entity.courseHours;
    },
    // getCurrentSections
    currentSectionsFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.today = entity && entity.date;
      state.sections = entity && entity.sections;
      state.dailyCourseHour = entity && entity.dailyCourseHour;
    },
    // getSections
    sectionsFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = entities;
    },
    // getStudents
    studentsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
      state.studentAttendances = [];
      entities && entities.forEach(entity => state.studentAttendances.push({ id: entity.id, attendanceStatus: entity.attendanceStatus }));
    },
    // getAttendanceReport
    attendanceReportFetched: (state, action) => {
      const { isSuccess, type, totalCount, authorities, entities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;      
      state.totalCount = totalCount;
      state.authorities = authorities;
      state.entities = [];

      entities && entities.forEach(entity => {
        const newEntity = {
          studentNumber: entity.studentNumber,
          studentName: entity.studentName
        };
        for (let i = 0; i < state.dailyCourseHour; i++) newEntity["courseHour" + (i + 1)] = entity.attendanceStatuses[i];
        state.entities.push(newEntity);
      });      
    },
    // getAbsenteeismReport
    absenteeismReportFetched:(state, action) => {
      const { isSuccess, type, totalCount, authorities, entities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.totalCount = totalCount;
      state.authorities = authorities;
      state.entities = entities;
    },
    // getAbsenteeismDetail
    absenteeismDetailFetched:(state, action) => {
      const { authorities, entity } = action.payload;
      state.actionsLoading = false;
      state.authorities = authorities;
      state.absenteeismDetail = entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanEntitiesState
    entitiesStateCleaned: (state) => {
      state.entities = [];
    },
    //cleanAbsenteeismDetailState
    absenteeismDetailStateCleaned: (state) => {
      state.actionsLoading = false;
      state.absenteeismDetail = undefined;
    },
    //cleanTeacherAttendanceState
    teacherAttendanceStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.sections = [];
      state.entities = [];
      state.courseHours = [];
      state.studentAttendances = [];
    }
  }
});